module.exports = __webpack_public_path__ + "static/media/icon_bed.bac35a5d.svg";